var map = {
	"./css.svg": 2180,
	"./express.svg": 2475,
	"./firebase.svg": 9939,
	"./i18n.svg": 3890,
	"./javascript.svg": 6923,
	"./mysql.svg": 589,
	"./nestjs.svg": 297,
	"./nuxtjs.svg": 6876,
	"./sass.svg": 1818,
	"./typescript.svg": 6891,
	"./vue-js.svg": 3429,
	"./vuetify.svg": 2377
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5877;